export class DefaultAccountMeta {
  relationshipType?: string;
  otherRelationshipType?: string;
  category?: string;
  isNextOfKin?: boolean;
  deceasedBeneficiaryHadChildren?: boolean;
  hasLegalGuardian?: boolean;
  willActAsPersonalRepresentative?: boolean;
  reasonForExecutorship?: string;
  reasonForExecutorshipOtherExplanation?: string;

  constructor(model: Partial<DefaultAccountMeta> = {}) {
    this.relationshipType = model.relationshipType;
    this.otherRelationshipType = model.otherRelationshipType;
    this.category = model.category;
    this.isNextOfKin = model.isNextOfKin;
    this.deceasedBeneficiaryHadChildren = model.deceasedBeneficiaryHadChildren;
    this.hasLegalGuardian = model.hasLegalGuardian;
    this.willActAsPersonalRepresentative = model.willActAsPersonalRepresentative;
    this.reasonForExecutorship = model.reasonForExecutorship;
    this.reasonForExecutorshipOtherExplanation = model.reasonForExecutorshipOtherExplanation;
  }
}
